import { useEffect, useRef, useState } from 'react';
/** True for a moment after `on` turns true — for «Сохранено», «Очищено» and the like. */
export function useFlash(on, ms = 1800) {
    const [flash, setFlash] = useState(false);
    const was = useRef(on);
    useEffect(() => {
        const flipped = on && !was.current;
        was.current = on;
        if (!flipped)
            return;
        setFlash(true);
        const t = window.setTimeout(() => setFlash(false), ms);
        return () => window.clearTimeout(t);
    }, [on, ms]);
    return flash;
}
